import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import NotFound from '../pages/NotFound';
import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { AdminLayout } from '@/admin/layout/AdminLayout';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const SolutionsPage = lazy(() => import('../pages/solutions/page'));
const SolutionDetailPage = lazy(() => import('../pages/solutions/detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog/article/page'));

const AdminLogin = lazy(() => import('../admin/pages/AdminLogin').then(m => ({ default: m.AdminLogin })));
const Dashboard = lazy(() => import('../admin/pages/Dashboard').then(m => ({ default: m.Dashboard })));
const ServicesAdmin = lazy(() => import('../admin/pages/ServicesAdmin').then(m => ({ default: m.ServicesAdmin })));
const SolutionsAdmin = lazy(() => import('../admin/pages/SolutionsAdmin').then(m => ({ default: m.SolutionsAdmin })));
const CaseStudiesAdmin = lazy(() => import('../admin/pages/CaseStudiesAdmin').then(m => ({ default: m.CaseStudiesAdmin })));
const TestimonialsAdmin = lazy(() => import('../admin/pages/TestimonialsAdmin').then(m => ({ default: m.TestimonialsAdmin })));
const TeamAdmin = lazy(() => import('../admin/pages/TeamAdmin').then(m => ({ default: m.TeamAdmin })));
const BlogAdmin = lazy(() => import('../admin/pages/BlogAdmin').then(m => ({ default: m.BlogAdmin })));
const PartnersAdmin = lazy(() => import('../admin/pages/PartnersAdmin').then(m => ({ default: m.PartnersAdmin })));
const ContactInquiriesAdmin = lazy(() => import('../admin/pages/ContactInquiriesAdmin').then(m => ({ default: m.ContactInquiriesAdmin })));
const NewsletterAdmin = lazy(() => import('../admin/pages/NewsletterAdmin').then(m => ({ default: m.NewsletterAdmin })));
const UsersAdmin = lazy(() => import('../admin/pages/UsersAdmin').then(m => ({ default: m.UsersAdmin })));
const SiteSettingsAdmin = lazy(() => import('../admin/pages/SiteSettingsAdmin').then(m => ({ default: m.SiteSettingsAdmin })));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/solutions',
    element: <SolutionsPage />,
  },
  {
    path: '/solutions/:slug',
    element: <SolutionDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogArticlePage />,
  },
  {
    path: '/admin',
    children: [
      {
        path: 'login',
        element: <AdminLogin />,
      },
      {
        element: (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <Dashboard /> },
          { path: 'services', element: <ServicesAdmin /> },
          { path: 'solutions', element: <SolutionsAdmin /> },
          { path: 'case-studies', element: <CaseStudiesAdmin /> },
          { path: 'testimonials', element: <TestimonialsAdmin /> },
          { path: 'team', element: <TeamAdmin /> },
          { path: 'partners', element: <PartnersAdmin /> },
          { path: 'blog', element: <BlogAdmin /> },
          { path: 'notifications', element: <ContactInquiriesAdmin /> },
          { path: 'newsletter', element: <NewsletterAdmin /> },
          { path: 'users', element: <UsersAdmin /> },
          { path: 'site-settings', element: <SiteSettingsAdmin /> },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;